(function ($) {
	function sliderModule() {
		// @ts-ignore-next
		$('.slider-module').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			dots: true,
			customPaging: function () {
				return '<span class="slider-dot"></span>';
			},
			arrows: false,
			swipeToSlide: true,
			infinite: false,
		});

		// @ts-ignore-next
		$('.slider-module').slickLightbox({
			lazy: true,
			itemSelector: 'a',
			navigateByKeyboard: true,
		});
	}

	sliderModule();
})(jQuery);
